export const talksMain = [
  {
    time: "10:00 AM",
    title: "Welcome to Schelling Point",
    name: `Simona Pop ◖ SP Content Curator`,
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=Nzh2MjN1b3RtMzFyMDl1cmltMmFsZzhhbXAgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "10:10 AM",
    title: "DAOs & Network States",
    name: "Balaji Srinivasan",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=M25razBqc3F2Y3FyN2o0djZqcTA5YjQwdXAgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "10:30 AM",
    title: "New Form Factors for Quadratic Funding",
    name: "Kevin Owocki ◖ Supermodular",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=N2plYjQ3bzhxMDBpZm9hMW5vZWZnM3JrMm8gNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "10:50 AM",
    title: "Radicle Drips: New Economic Primitives for Public Goods Funding",
    name: "Andrew Dickson ◖ Drips",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NnVnOWhpMnJoMjJkdTVnMjNicjg5amJiN2ogNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "11:10 AM",
    title: "How crypto protocols impact our psychology",
    name: "David Hoffman ◖ Bankless",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MmF0bTlzdWE5MGpvbmRxb2hoOHAyOTc1NGUgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "11:30 AM",
    title:
      "How The FiatConnect Public Good Is Delivering on The Promise of Web3 Payments in Nigeria, Kenya and the Philippines",
    name: "Marek Olszewski ◖ Celo",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NWpwc3JucDNhcmhrajRkNnZjMjI4ZnZhc2MgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "11:55 AM",
    title: "Planetary Health Futures: tools for imagination + action",
    name: "Louis Parker, Dimitri De Jonghe",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MDNybTNvOXZ2MDFsN2djZG9qamFsdmFkbm8gNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "12:15 PM",
    title:
      "Bootstrapping Impact Markets: A Study of Carbon Credits as Impact Certificates",
    name: "Marcus Aurelius ◖ Klima DAO",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T191500Z%2F20230302T193500Z&details=&location=National%20Western%20Complex&text=Bootstrapping%20Impact%20Markets%3A%20A%20Study%20of%20Carbon%20Credits%20as%20Impact%20Certificates%20%28Marcus%20Aurelius%20%E2%97%96%20Klima%20DAO%29",
  },
  {
    time: "12:35 PM",
    title: "LUNCH",
    name: "",
    calendar: "",
  },
  {
    time: "12:55 PM",
    title: "Scaling coordination with impact evaluators",
    name: "Joel Thorstensson ◖ Ceramic",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NmNwazFlcGoybXY1OGRmZ2k5cnJkaGIzc28gNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "1:15 PM",
    title: "Towards a cybernetic cryptoeconomics",
    name: "Christopher Goes",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NHBkMWMzOG5tb2FoNW44YXA1Z3FuZ2Q5azEgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "1:35 PM",
    title: "Crypto and Civil Liberties",
    name: "Marta Belcher ◖ Filecoin Foundation",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NzNnZmw2NWhndjM2NHBuN3Bza21zMGh1czIgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "1:55 PM",
    title: "PG Funding Panel",
    name: "Scott Moore ◖ Gitcoin, Awa Sun ◖ Anoma, Zaki Manian ◖ Cosmos, Daniel Hwang ◖ ",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T205500Z%2F20230302T211500Z&details=&location=National%20Western%20Complex&text=PG%20Funding%20Panel%20%28Scott%20Moore%20%E2%97%96%20Gitcoin%2C%20Awa%20Sun%20%E2%97%96%20Anoma%2C%20Zaki%20Manian%20%E2%97%96%20Cosmos%2C%20Daniel%20Hwang%29",
  },
  {
    time: "2:15 PM",
    title: `Introducing the New Creative Economies`,
    name: "Fabian Vogelsteller ◖ Lukso",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MHZxb3M1MTJmNWJsbWhrOTE0ZWZxdWJwMjkgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "2:35 PM",
    title: "Decentralized Science and VC’s responsibility in the movement",
    name: "Forest Bai ◖ Foresight Ventures",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=N2JnZGxvbTFxZDFkN29sYzA1ZGFlZGMxZ2QgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "2:55 PM",
    title:
      "An Antidote to Big Tech’s Harms: Equitable Ownership and Governance in the Online Economy",
    name: "Connor Spelliscy, Nathan Schneider, Yev MUCHNIK, Sarah Hubbard",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MDczMWJ0cmZrdWRuaTVvZ3N0amJxN2V2a2wgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "3:20 PM",
    title: "Account Abstraction: the Pathway to Mass Adoption",
    name: "Ramon Canales ◖ Matter Labs | zkSync",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T222000Z%2F20230302T224500Z&details=&location=National%20Western%20Complex&text=Account%20Abstraction%3A%20the%20Pathway%20to%20Mass%20Adoption%20%28Ramon%20Canales%20%E2%97%96%20Matter%20Labs%20%7C%20zkSync%29",
  },
  {
    time: "3:45 PM",
    title: `Let's Take Back the Town Square`,
    name: "Stani Kulechov ◖ Aave",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MG50OWc5ZDhvOWE0aW5iamY2bGRuZGI3ZHMgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "4:05 PM",
    title: "Protocol Guild: 1 year old",
    name: "Trent Van Epps ◖ Protocol Guild",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=MGk0M3NwN2plcmU4ZDNncG5vZGY0bGdlcW0gNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "4:25 PM",
    title: `The Other Burn`,
    name: "Simona Pop, Amy Jung, Hudson Jameson, Maria Magenes",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=N3RxdGxvMWpuNnFmY2dzcmVtNXM4c3FmaTYgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "4:50 PM",
    title:
      "Cities Thrive When They Tithe: How the Economics of Tithing Will Fund Your Vision for Free",
    name: "Niran Babalola ◖ Panvala",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NTJ1MXFpZDNvMzJiczJ2aGFob2xrdmIzaDUgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
  {
    time: "5:10 PM",
    title: `Civic Innovation For People & Planet`,
    name: "Benjamin LIfe & Timothy Archer ◖ OpenCivics",
    link: "https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NXZlbzdlYzM1djZuMjV0MmVuYXJqN2xuMHYgNDI0M2VhZjU3MWZlNzJlOTI0ZmU1MGI2NzIzMzkzY2Y1MmU0YWIxN2FlOTZlNTU1ZDViYzUzM2ZiNWUzYTExZEBn&tmsrc=4243eaf571fe72e924fe50b6723393cf52e4ab17ae96e555d5bc533fb5e3a11d%40group.calendar.google.com",
  },
];

export const Unconference = [
  // {
  //   time: "10:00 AM",
  //   title: "Welcome to Schelling Point",
  //   name: `Simona Pop ◖ SP Content Curator`,
  // link: '', },
  {
    time: "10:20 AM",
    title:
      "Regenerative Employment: The Impact of DAOs and Empowering Individuals",
    name: "Rachel Brissenden ◖Opolis",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T172000Z%2F20230302T174000Z&details=&location=National%20Western%20Complex&text=Regenerative%20Employment%3A%20The%20Impact%20of%20DAOs%20and%20Empowering%20Individuals%20%28Rachel%20Brissenden%20%E2%97%96Opolis%29",
  },
  {
    time: "10:40 AM",
    title: "Seeing The World Through Social Graphs",
    name: "Billy Luedtke ◖ Intuition",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T174000Z%2F20230302T180000Z&details=&location=National%20Western%20Complex&text=Seeing%20The%20World%20Through%20Social%20Graphs%20%28Billy%20Luedtke%20%E2%97%96%20Intuition%29",
  },

  {
    time: "11:00 AM",
    title: "Educational Webs",
    name: "Vivek Singh ◖ kernel",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T180000Z%2F20230302T182500Z&details=&location=National%20Western%20Complex&text=Educational%20Webs%20%28Vivek%20Singh%20%E2%97%96%20kernel%29",
  },
  {
    time: "11:25 AM",
    title: "What permaculture can teach web3",
    name: "Gregory Landua ◖ Regen Network",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T182500Z%2F20230302T184500Z&details=&location=National%20Western%20Complex&text=What%20permaculture%20can%20teach%20web3%20%28Gregory%20Landua%20%E2%97%96%20Regen%20Network%29",
  },
  {
    time: "11:45 AM",
    title: `Designing for Resilience in Open-Source Ecosystems`,
    name: "Abbey Titcomb",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T184500Z%2F20230302T190500Z&details=&location=National%20Western%20Complex&text=Designing%20for%20Resilience%20in%20Open-Source%20Ecosystems%20%28Abbey%20Titcomb%29",
  },
  {
    time: "12:05 PM",
    title: "Grow groups sustainably through personalized experiences",
    name: "Reka.eth ◖ Guild",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T190500Z%2F20230302T192500Z&details=&location=National%20Western%20Complex&text=Grow%20groups%20sustainably%20through%20personalized%20experiences%20%28Reka.eth%20%E2%97%96%20Guild%29",
  },
  {
    time: "12:25 PM",
    title: "LUNCH",
    name: "",
    link: "",
  },
  {
    time: "1:10 PM",
    title: "Beyond Code is Law: A Workshop on DAO Constitutions",
    name: `Kyle Smith | bestape ◖ Lex Dao`,
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T201000Z%2F20230302T203000Z&details=&location=National%20Western%20Complex&text=Beyond%20Code%20is%20Law%3A%20A%20Workshop%20on%20DAO%20Constitutions%20%28Kyle%20Smith%20%7C%20bestape%20%E2%97%96%20Lex%20Dao%29",
  },
  {
    time: "1:30 PM",
    title:
      "United Species DAO: Locally-Led Climate Resilience for All through ReFi",
    name: "Agustin Matteri, Deepa Chaudhary and Paula Doy",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T203000Z%2F20230302T205000Z&details=&location=National%20Western%20Complex&text=United%20Species%20DAO%3A%20Locally-Led%20Climate%20Resilience%20for%20All%20through%20ReFi%20%28Agustin%20Matteri%2C%20Deepa%20Chaudhary%20and%20Paula%20Doy%29",
  },
  {
    time: "1:50 PM",
    title: "Giving nature a voice (and a wallet)",
    name: "Matthew Monahan Biome ◖ Trust",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T205000Z%2F20230302T211000Z&details=&location=National%20Western%20Complex&text=Giving%20nature%20a%20voice%20%28and%20a%20wallet%29%20%28Matthew%20Monahan%20Biome%20%E2%97%96%20Trust%29",
  },
  {
    time: "2:10 PM",
    title: "Hypnotic induction to the Decentralized Autonomous Hyperspa",
    name: "Gabriel Tumlos ◖ Mochi",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T211000Z%2F20230302T213000Z&details=&location=National%20Western%20Complex&text=Hypnotic%20induction%20to%20the%20Decentralized%20Autonomous%20Hyperspa%20%28Gabriel%20Tumlos%20%E2%97%96%20Mochi%29",
  },
  {
    time: "2:30 PM",
    title: "The Collective DAO Archives",
    name: "Justine Humenansky ◖ Optimism",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T213000Z%2F20230302T215000Z&details=&location=National%20Western%20Complex&text=The%20Collective%20DAO%20Archives%20%28Justine%20Humenansky%20%E2%97%96%20Optimism%29",
  },
  {
    time: "2:50 PM",
    title:
      "What Do High Schoolers Today Need to Learn to Prepare for Decentralized Careers?",
    name: "Bethany Crystal",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T215000Z%2F20230302T221000Z&details=&location=National%20Western%20Complex&text=What%20Do%20High%20Schoolers%20Today%20Need%20to%20Learn%20to%20Prepare%20for%20Decentralized%20Careers%3F%20%28Bethany%20Crystal%29",
  },
  {
    time: "3:10 PM",
    title: "Accelerating the Pace of Science: ResearchHub",
    name: "Tyler Diorio ◖ Research Hub",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T221000Z%2F20230302T223000Z&details=&location=National%20Western%20Complex&text=Accelerating%20the%20Pace%20of%20Science%3A%20ResearchHub%20%28Tyler%20Diorio%20%E2%97%96%20Research%20Hub%29",
  },
  {
    time: "3:30 PM",
    title: "How web3 will save the arts as a public good",
    name: "Helena Gagern ◖ Salsa",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T223000Z%2F20230302T225000Z&details=&location=National%20Western%20Complex&text=How%20web3%20will%20save%20the%20arts%20as%20a%20public%20good%20%28Helena%20Gagern%20%E2%97%96%20Salsa%29",
  },
  {
    time: "3:50 PM",
    title: "Flexible Voting: How GitcoinDAO can Level Up On-Chain Governance",
    name: "Ben DiFrancesco ◖ ScopeLift",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T225000Z%2F20230302T231000Z&details=&location=National%20Western%20Complex&text=Flexible%20Voting%3A%20How%20GitcoinDAO%20can%20Level%20Up%20On-Chain%20Governance%20%28Ben%20DiFrancesco%20%E2%97%96%20ScopeLift%29",
  },
  {
    time: "4:10 PM",
    title: "The Future of Grants",
    name: `Kevin Olsen ◖ Gitcoin, Riccardo Lamanna ◖ OpenQ, Vikram Aditya ◖ DaoLens, Balázs Némethi ◖ kycDAO, Joshua Tan (Moderator)`,
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T231000Z%2F20230302T234000Z&details=&location=National%20Western%20Complex&text=The%20Future%20of%20Grants%20%28Kevin%20Olsen%20%E2%97%96%20Gitcoin%2C%20Riccardo%20Lamanna%20%E2%97%96%20OpenQ%2C%20Vikram%20Aditya%20%E2%97%96%20DaoLens%2C%20Bal%C3%A1zs%20N%C3%A9methi%20%E2%97%96%20kycDAO%2C%20Joshua%20Tan%20%28Moderator%29%29",
  },
  {
    time: "4:40 PM",
    title: "SocietyOS: Crowdsourcing Civilization Designs Workshop",
    name: "Elliott Bayev ◖ Global Unity",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T234000Z%2F20230303T000000Z&details=&location=National%20Western%20Complex&text=SocietyOS%3A%20Crowdsourcing%20Civilization%20Designs%20Workshop%20%28Elliott%20Bayev%20%E2%97%96%20Global%20Unity%29",
  },
  {
    time: "5:00 PM",
    title: "Decentralized Future of Natural Medicines",
    name: `Mod: Reilly Capps, Sovereign Oshumare, Matthew Duffy, Travis Fluck, Valinda Jones`,
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230303T000000Z%2F20230303T003000Z&details=&location=National%20Western%20Complex&text=Decentralized%20Future%20of%20Natural%20Medicines%20%28Mod%3A%20Reilly%20Capps%2C%20Sovereign%20Oshumare%2C%20Matthew%20Duffy%2C%20Travis%20Fluck%2C%20Valinda%20Jones%29",
  },
];

export const desciTalks = [
  // {
  //   time: "10:00 AM",
  //   title: "Welcome to Schelling Point",
  //   name: `Simona Pop ◖ SP Content Curator`,
  // link: '', },
  {
    time: "10:30 AM",
    title: "Open Science and Decentralized Science",
    name: "Jonathan Starr ◖ DeSci Labs, Shady El Damaty ◖ OpSci",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T173000Z%2F20230302T180000Z&details=&location=National%20Western%20Complex&text=Open%20Science%20and%20Decentralized%20Science%20%28Jonathan%20Starr%20%E2%97%96%20DeSci%20Labs%2C%20Shady%20El%20Damaty%20%E2%97%96%20OpSci%29",
  },
  {
    time: "11:00 AM",
    title: "Funding far-out longevity research",
    name: "Emil Kendziorra ◖ CryoDAO",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T180000Z%2F20230302T181500Z&details=&location=National%20Western%20Complex&text=Funding%20far-out%20longevity%20research%20%28Emil%20Kendziorra%20%E2%97%96%20CryoDAO%29",
  },
  {
    time: "11:15 AM",
    title: "Prefigurative Self Infrastructuring",
    name: "Michael Zargham ◖ BlockScience",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T181500Z%2F20230302T183000Z&details=&location=National%20Western%20Complex&text=Prefigurative%20Self%20Infrastructuring%20%28Michael%20Zargham%20%E2%97%96%20BlockScience%29",
  },
  {
    time: "11:30 AM",
    title:
      "Universities and the new world of accreditation and knowledge stewardship",
    name: "Jonathan Starr ◖ DeSci Labs, Jonathan Kung ◖ Science Publishing DAO, Tammy Francis ◖ Catalyst 4 Change Global",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T183000Z%2F20230302T190000Z&details=&location=National%20Western%20Complex&text=Universities%20and%20the%20new%20world%20of%20accreditation%20and%20knowledge%20stewardship%20%28Jonathan%20Starr%20%E2%97%96%20DeSci%20Labs%2C%20Jonathan%20Kung%20%E2%97%96%20Science%20Publishing%20DAO%2C%20Tammy%20Francis%20%E2%97%96%20Catalyst%204%20Change%20Global%29",
  },
  {
    time: "12:00 PM",
    title: "LUNCH",
    name: "",
  },
  {
    time: "1:00 PM",
    title: "Gitcoin Grants & DeSci",
    name: "Boris Dyakov ◖ Gitcoin, Azeem Khan ◖ Gitcoin, Jonathan Starr ◖ DeSci Labs, Shady El Damaty ◖ OpSci, Allison Duettmann ◖ Foresight Institute, Manveer Basra ◖ Scholar, Martin Karlsson ◖ Lateral.io/desci, Keith Comito ◖ Lifespan.io, Francisco Diaz ◖ talentDAO",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T200000Z%2F20230302T203000Z&details=&location=National%20Western%20Complex&text=Gitcoin%20Grants%20%26%20DeSci%20%28Boris%20Dyakov%20%E2%97%96%20Gitcoin%2C%20Azeem%20Khan%20%E2%97%96%20Gitcoin%2C%20Jonathan%20Starr%20%E2%97%96%20DeSci%20Labs%2C%20Shady%20El%20Damaty%20%E2%97%96%20OpSci%2C%20Allison%20Duettmann%20%E2%97%96%20Foresight%20Institute%2C%20Manveer%20Basra%20%E2%97%96%20Scholar%2C%20Martin%20Karlsson%20%E2%97%96%20Lateral.io%2Fdesci%2C%20Keith%20Comito%20%E2%97%96%20Lifespan.io%2C%20Francisco%20Diaz%20%E2%97%96%20talentDAO%29",
  },
  {
    time: "1:30 PM",
    title: "Digital Identity for Web Native Scientists",
    name: "Shady El Damaty ◖ OpSci, Laure Haak ◖ Mighty Red Barn, Joel Thorstensson ◖ Ceramic",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T203000Z%2F20230302T210000Z&details=&location=National%20Western%20Complex&text=Digital%20Identity%20for%20Web%20Native%20Scientists%20%28Shady%20El%20Damaty%20%E2%97%96%20OpSci%2C%20Laure%20Haak%20%E2%97%96%20Mighty%20Red%20Barn%2C%20Joel%20Thorstensson%20%E2%97%96%20Ceramic%29",
  },
  {
    time: "2:00 PM",
    title: "Metascience",
    name: "Jonathan Kung ◖ Science Publishing DAO",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T210000Z%2F20230302T211500Z&details=&location=National%20Western%20Complex&text=Metascience%20%28Jonathan%20Kung%20%E2%97%96%20Science%20Publishing%20DAO%29",
  },
  {
    time: "2:15 PM",
    title: "Designing for your Users",
    name: "Phil Hedayatnia ◖ Airfoil",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T211500Z%2F20230302T213500Z&details=&location=National%20Western%20Complex&text=Designing%20for%20your%20Users%20%28Phil%20Hedayatnia%20%E2%97%96%20Airfoil%29",
  },
  {
    time: "2:35 PM",
    title: "Tech Interoperability & Standards",
    name: "Omar ElNaggar ◖ Weavechain",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T213500Z%2F20230302T220500Z&details=&location=National%20Western%20Complex&text=Tech%20Interoperability%20%26%20Standards%20%28Omar%20ElNaggar%20%E2%97%96%20Weavechain%29",
  },
  {
    time: "3:05 PM",
    title: "Decentralized AI & Compute for Public Goods",
    name: "Don Gossen ◖ Nevermined, Richard Blythman ◖ Algovera, Erik Allberg ◖ dao.xyz, David Aronchick ◖ Bacalhau, Tom Trowbridge ◖ Fluence Labs",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T220500Z%2F20230302T224500Z&details=&location=National%20Western%20Complex&text=Decentralized%20AI%20%26%20Compute%20for%20Public%20Goods%20%28Don%20Gossen%20%E2%97%96%20Nevermined%2C%20Richard%20Blythman%20%E2%97%96%20Algovera%2C%20Erik%20Allberg%20%E2%97%96%20dao.xyz%2C%20David%20Aronchick%20%E2%97%96%20Bacalhau%2C%20Tom%20Trowbridge%20%E2%97%96%20Fluence%20Labs%29",
  },
  {
    time: "3:45 PM",
    title: "Alternative Ways to De-Risk Funding of Research",
    name: "Jeffery Joh ◖ and Benji Leibowitz ◖ VitaDAO",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T224500Z%2F20230302T231500Z&details=&location=National%20Western%20Complex&text=Alternative%20Ways%20to%20De-Risk%20Funding%20of%20Research%20%28Jeffery%20Joh%20%E2%97%96%20and%20Benji%20Leibowitz%20%E2%97%96%20VitaDAO%29",
  },
  {
    time: "4:15 PM",
    title: "New Funding Models for DeSci",
    name: "Keith Comito ◖ Lifespan.io, Qing Ze, Robbie Hegger",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T231500Z%2F20230302T234500Z&details=&location=National%20Western%20Complex&text=New%20Funding%20Models%20for%20DeSci%20%28Keith%20Comito%20%E2%97%96%20Lifespan.io%2C%20Qing%20Ze%2C%20Robbie%20Hegger%29",
  },
];

export const desciWorkshops = [
  // {
  //   time: "10:00 AM",
  //   title: "Welcome to Schelling Point",
  //   name: `Simona Pop ◖ SP Content Curator`,
  // link: '', },
  {
    time: "10:30 AM",
    title: "DEI in DeSci",
    name: "Tammy Francis ◖ Catalyst 4 Change Global",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T173000Z%2F20230302T183000Z&details=&location=National%20Western%20Complex&text=DEI%20in%20DeSci%20%28Tammy%20Francis%20%E2%97%96%20Catalyst%204%20Change%20Global%29",
  },
  {
    time: "11:30 AM",
    title: "Ethics in DeSci",
    name: "Joshua Bate ◖ DeSciWorld and Jelani Clarke ◖ DeSciWorld",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T183000Z%2F20230302T191000Z&details=&location=National%20Western%20Complex&text=Ethics%20in%20DeSci%20%28Joshua%20Bate%20%E2%97%96%20DeSciWorld%20and%20Jelani%20Clarke%20%E2%97%96%20DeSciWorld%29",
  },
  {
    time: "12:10 PM",
    title: "LUNCH",
    name: "",
  },
  {
    time: "1:00 PM",
    title: "X-Community-Schmooze",
    name: "Boris Dyakov ◖ Gitcoin, Sage Shelton ◖ ReSci Network",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T200000Z%2F20230302T204000Z&details=&location=National%20Western%20Complex&text=X-Community-Schmooze%20%28Boris%20Dyakov%20%E2%97%96%20Gitcoin%2C%20Sage%20Shelton%20%E2%97%96%20ReSci%20Network%29",
  },
  {
    time: "1:40 PM",
    title: "Tech-Tree",
    name: "Allison Duettmann ◖ Foresight Institute",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T204000Z%2F20230302T212000Z&details=&location=National%20Western%20Complex&text=Tech-Tree%20%28Allison%20Duettmann%20%E2%97%96%20Foresight%20Institute%29",
  },
  {
    time: "2:20 PM",
    title: "Incentivization Workshop: Build your own nation",
    name: "Jonathan Starr",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T212000Z%2F20230302T220000Z&details=&location=National%20Western%20Complex&text=Incentivization%20Workshop%3A%20Build%20your%20own%20nation%20%28Jonathan%20Starr%29",
  },
  {
    time: "3:00 PM",
    title: "Tools Tables",
    name: "Jonathan Starr ◖ Gridcoin, David Aronchick ◖ bacalhau, Don Gossen ◖Nevermined AG, Richard Blythman ◖ Algovera, Michael Fischer ◖ DBDAO.xyz, Omar ElNaggar ◖ Weavechain, Manveer Basra ◖ Scholar, Jacob Luo, Allison Duettmann ◖ Foresight Institute, Derek Anderson ◖ Blockless, Carla Ostmann ◖ DeSci Labs, Jesse Hudson ◖ Molecule, Nanak Nihal Khalsa ◖ Holonym",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T220000Z%2F20230302T230000Z&details=&location=National%20Western%20Complex&text=Tools%20Tables%20%28Jonathan%20Starr%20%E2%97%96%20Gridcoin%2C%20David%20Aronchick%20%E2%97%96%20bacalhau%2C%20Don%20Gossen%20%E2%97%96Nevermined%20AG%2C%20Richard%20Blythman%20%E2%97%96%20Algovera%2C%20Michael%20Fischer%20%E2%97%96%20DBDAO.xyz%2C%20Omar%20ElNaggar%20%E2%97%96%20Weavechain%2C%20Manveer%20Basra%20%E2%97%96%20Scholar%2C%20Jacob%20Luo%2C%20Allison%20Duettmann%20%E2%97%96%20Foresight%20Institute%2C%20Derek%20Anderson%20%E2%97%96%20Blockless%2C%20Carla%20Ostmann%20%E2%97%96%20DeSci%20Labs%2C%20Jesse%20Hudson%20%E2%97%96%20Molecule%2C%20Nanak%20Nihal%20Khalsa%20%E2%97%96%20Holonym%29",
  },
  {
    time: "4:00 PM",
    title: "Unconference",
    name: "Everyone!",
    link: "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230302T230000Z%2F20230303T003000Z&details=&location=National%20Western%20Complex&text=Unconference%20%28Everyone%21%29",
  },
];
